module.exports = __webpack_public_path__ + "img/undo.6d27ddb5.svg";